export const getMonthlyCost = (cost: number | null | undefined) => {
    if (cost === null || cost === undefined) return;
    return cost / 12;
}

export const getTaxAmount = (taxRate: number | null | undefined, monthlyCost: number | null | undefined) => {
    if (taxRate === null || taxRate === undefined || monthlyCost === null || monthlyCost === undefined) return;
    return monthlyCost * taxRate;
}

export const getTotalMonthlyCost = (monthlyCost: number | null | undefined, taxAmount: number | null | undefined) => {
    if (monthlyCost === null || monthlyCost === undefined) return;
    const tax = taxAmount !== null && taxAmount !== undefined ? taxAmount : 0;
    return monthlyCost + tax;
}